import * as Mod1 from "./discourse/adapters/discourse-post-event-adapter";
import * as Mod2 from "./discourse/adapters/discourse-post-event-event";
import * as Mod3 from "./discourse/adapters/discourse-post-event-invitee";
import * as Mod4 from "./discourse/adapters/discourse-post-event-nested-adapter";
import * as Mod5 from "./discourse/adapters/discourse-post-event-reminder";
import * as Mod6 from "./discourse/admin-calendar-route-map";
import * as Mod7 from "./discourse/api-initializers/discourse-group-timezones";
import * as Mod8 from "./discourse/components/admin-holidays-list-item";
import * as Mod9 from "./discourse/components/admin-holidays-list";
import * as Mod10 from "./discourse/components/bulk-invite-sample-csv-file";
import * as Mod11 from "./discourse/components/category-calendar";
import * as Mod12 from "./discourse/components/compact-event-editor";
import * as Mod13 from "./discourse/components/composer-event-editor";
import * as Mod14 from "./discourse/components/csv-uploader";
import * as Mod15 from "./discourse/components/discourse-post-event/chat-channel";
import * as Mod16 from "./discourse/components/discourse-post-event/creator";
import * as Mod17 from "./discourse/components/discourse-post-event/dates";
import * as Mod18 from "./discourse/components/discourse-post-event/description";
import * as Mod19 from "./discourse/components/discourse-post-event/event-status";
import * as Mod20 from "./discourse/components/discourse-post-event/image";
import * as Mod21 from "./discourse/components/discourse-post-event/index";
import * as Mod22 from "./discourse/components/discourse-post-event/invitee";
import * as Mod23 from "./discourse/components/discourse-post-event/invitees";
import * as Mod24 from "./discourse/components/discourse-post-event/livestream";
import * as Mod25 from "./discourse/components/discourse-post-event/location";
import * as Mod26 from "./discourse/components/discourse-post-event/more-menu";
import * as Mod27 from "./discourse/components/discourse-post-event/onebox-node-view";
import * as Mod28 from "./discourse/components/discourse-post-event/onebox-preview";
import * as Mod29 from "./discourse/components/discourse-post-event/status";
import * as Mod30 from "./discourse/components/discourse-post-event/url";
import * as Mod31 from "./discourse/components/event-date";
import * as Mod32 from "./discourse/components/event-node-view";
import * as Mod33 from "./discourse/components/full-calendar";
import * as Mod34 from "./discourse/components/group-timezones/index";
import * as Mod35 from "./discourse/components/group-timezones/new-day";
import * as Mod36 from "./discourse/components/group-timezones/time-traveller";
import * as Mod37 from "./discourse/components/group-timezones/timezone";
import * as Mod38 from "./discourse/components/livestream/embeddable-chat-channel";
import * as Mod39 from "./discourse/components/livestream/mobile-livestream-chat-icon";
import * as Mod40 from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
import * as Mod41 from "./discourse/components/livestream/responsive-livestream-chat-icon";
import * as Mod42 from "./discourse/components/livestream/zoom-entry";
import * as Mod43 from "./discourse/components/livestream/zoom-page";
import * as Mod44 from "./discourse/components/modal/post-event-builder";
import * as Mod45 from "./discourse/components/modal/post-event-bulk-invite";
import * as Mod46 from "./discourse/components/modal/post-event-invite-user-or-group";
import * as Mod47 from "./discourse/components/modal/post-event-invitees/index";
import * as Mod48 from "./discourse/components/modal/post-event-invitees/user";
import * as Mod49 from "./discourse/components/post-calendar";
import * as Mod50 from "./discourse/components/region-input";
import * as Mod51 from "./discourse/components/toggle-invitees";
import * as Mod52 from "./discourse/components/upcoming-events-calendar";
import * as Mod53 from "./discourse/components/upcoming-events-list";
import * as Mod54 from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
import * as Mod55 from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
import * as Mod56 from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
import * as Mod57 from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
import * as Mod58 from "./discourse/connectors/chat-channel-card-cta/livestream-rsvp.gjs";
import * as Mod59 from "./discourse/connectors/chat-channel-preview-card-content/livestream-rsvp.gjs";
import * as Mod60 from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
import * as Mod61 from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
import * as Mod62 from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
import * as Mod63 from "./discourse/connectors/user-custom-preferences/region.gjs";
import * as Mod64 from "./discourse/controllers/admin-plugins/show/discourse-calendar-holidays";
import * as Mod65 from "./discourse/controllers/discourse-post-event-upcoming-events";
import * as Mod66 from "./discourse/controllers/discourse-post-event-upcoming-events/index";
import * as Mod67 from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
import * as Mod68 from "./discourse/discourse-calendar-topic-zoom-route-map";
import * as Mod69 from "./discourse/discourse-event-upcoming-events-route-map";
import * as Mod70 from "./discourse/helpers/format-event-name";
import * as Mod71 from "./discourse/helpers/format-future-date";
import * as Mod72 from "./discourse/initializers/add-create-event-composer-action";
import * as Mod73 from "./discourse/initializers/add-event-ui-builder";
import * as Mod74 from "./discourse/initializers/add-events-create-topic-button";
import * as Mod75 from "./discourse/initializers/add-upcoming-events-to-sidebar";
import * as Mod76 from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
import * as Mod77 from "./discourse/initializers/disable-sort";
import * as Mod78 from "./discourse/initializers/discourse-calendar";
import * as Mod79 from "./discourse/initializers/discourse-post-event-decorator";
import * as Mod80 from "./discourse/initializers/event-relative-date";
import * as Mod81 from "./discourse/initializers/livestream-chat-overrides";
import * as Mod82 from "./discourse/lib/calendar-locale";
import * as Mod83 from "./discourse/lib/calendar-view-helper";
import * as Mod84 from "./discourse/lib/colors";
import * as Mod85 from "./discourse/lib/discourse-markdown/discourse-calendar";
import * as Mod86 from "./discourse/lib/discourse-markdown/discourse-post-event-block";
import * as Mod87 from "./discourse/lib/discourse-markdown/livestream-preview";
import * as Mod88 from "./discourse/lib/event-preview";
import * as Mod89 from "./discourse/lib/event-recurrence";
import * as Mod90 from "./discourse/lib/event-relative-date";
import * as Mod91 from "./discourse/lib/fetch-zoom-join-payload";
import * as Mod92 from "./discourse/lib/format-event-for-calendar";
import * as Mod93 from "./discourse/lib/full-calendar-default-options";
import * as Mod94 from "./discourse/lib/guess-best-date-format";
import * as Mod95 from "./discourse/lib/livestream-rsvp";
import * as Mod96 from "./discourse/lib/livestream-utils";
import * as Mod97 from "./discourse/lib/load-zoom-meeting-sdk";
import * as Mod98 from "./discourse/lib/open-event-composer";
import * as Mod99 from "./discourse/lib/raw-event-helper";
import * as Mod100 from "./discourse/lib/regions";
import * as Mod101 from "./discourse/lib/round-time";
import * as Mod102 from "./discourse/lib/zoom-component-view-dom";
import * as Mod103 from "./discourse/lib/zoom-error";
import * as Mod104 from "./discourse/lib/zoom-meeting-session";
import * as Mod105 from "./discourse/models/discourse-post-event-event-stats";
import * as Mod106 from "./discourse/models/discourse-post-event-event";
import * as Mod107 from "./discourse/models/discourse-post-event-invitee";
import * as Mod108 from "./discourse/models/discourse-post-event-invitees";
import * as Mod109 from "./discourse/models/discourse-post-event-reminder";
import * as Mod110 from "./discourse/modifiers/open-links-in-new-tab";
import * as Mod111 from "./discourse/modifiers/zoom-component-view-layout";
import * as Mod112 from "./discourse/pre-initializers/rich-editor-extension";
import * as Mod113 from "./discourse/pre-initializers/transformers";
import * as Mod114 from "./discourse/routes/discourse-post-event-upcoming-events";
import * as Mod115 from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
import * as Mod116 from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
import * as Mod117 from "./discourse/routes/discourse-post-event-upcoming-events/index";
import * as Mod118 from "./discourse/routes/discourse-post-event-upcoming-events/mine";
import * as Mod119 from "./discourse/routes/topic-zoom";
import * as Mod120 from "./discourse/services/create-event-composer";
import * as Mod121 from "./discourse/services/discourse-post-event-api";
import * as Mod122 from "./discourse/services/discourse-post-event-service";
import * as Mod123 from "./discourse/services/embeddable-chat";
import * as Mod124 from "./discourse/services/post-calendar";
import * as Mod125 from "./discourse/templates/admin-plugins/show/discourse-calendar-holidays";
import * as Mod126 from "./discourse/templates/discourse-post-event-upcoming-events";
import * as Mod127 from "./discourse/templates/discourse-post-event-upcoming-events/index";
import * as Mod128 from "./discourse/templates/discourse-post-event-upcoming-events/mine";
import * as Mod129 from "./discourse/templates/topic-zoom";
const compatModules = {
  "discourse/adapters/discourse-post-event-adapter": Mod1,
  "discourse/adapters/discourse-post-event-event": Mod2,
  "discourse/adapters/discourse-post-event-invitee": Mod3,
  "discourse/adapters/discourse-post-event-nested-adapter": Mod4,
  "discourse/adapters/discourse-post-event-reminder": Mod5,
  "discourse/admin-calendar-route-map": Mod6,
  "discourse/api-initializers/discourse-group-timezones": Mod7,
  "discourse/components/admin-holidays-list-item": Mod8,
  "discourse/components/admin-holidays-list": Mod9,
  "discourse/components/bulk-invite-sample-csv-file": Mod10,
  "discourse/components/category-calendar": Mod11,
  "discourse/components/compact-event-editor": Mod12,
  "discourse/components/composer-event-editor": Mod13,
  "discourse/components/csv-uploader": Mod14,
  "discourse/components/discourse-post-event/chat-channel": Mod15,
  "discourse/components/discourse-post-event/creator": Mod16,
  "discourse/components/discourse-post-event/dates": Mod17,
  "discourse/components/discourse-post-event/description": Mod18,
  "discourse/components/discourse-post-event/event-status": Mod19,
  "discourse/components/discourse-post-event/image": Mod20,
  "discourse/components/discourse-post-event/index": Mod21,
  "discourse/components/discourse-post-event/invitee": Mod22,
  "discourse/components/discourse-post-event/invitees": Mod23,
  "discourse/components/discourse-post-event/livestream": Mod24,
  "discourse/components/discourse-post-event/location": Mod25,
  "discourse/components/discourse-post-event/more-menu": Mod26,
  "discourse/components/discourse-post-event/onebox-node-view": Mod27,
  "discourse/components/discourse-post-event/onebox-preview": Mod28,
  "discourse/components/discourse-post-event/status": Mod29,
  "discourse/components/discourse-post-event/url": Mod30,
  "discourse/components/event-date": Mod31,
  "discourse/components/event-node-view": Mod32,
  "discourse/components/full-calendar": Mod33,
  "discourse/components/group-timezones/index": Mod34,
  "discourse/components/group-timezones/new-day": Mod35,
  "discourse/components/group-timezones/time-traveller": Mod36,
  "discourse/components/group-timezones/timezone": Mod37,
  "discourse/components/livestream/embeddable-chat-channel": Mod38,
  "discourse/components/livestream/mobile-livestream-chat-icon": Mod39,
  "discourse/components/livestream/modal/mobile-embeddable-chat-modal": Mod40,
  "discourse/components/livestream/responsive-livestream-chat-icon": Mod41,
  "discourse/components/livestream/zoom-entry": Mod42,
  "discourse/components/livestream/zoom-page": Mod43,
  "discourse/components/modal/post-event-builder": Mod44,
  "discourse/components/modal/post-event-bulk-invite": Mod45,
  "discourse/components/modal/post-event-invite-user-or-group": Mod46,
  "discourse/components/modal/post-event-invitees/index": Mod47,
  "discourse/components/modal/post-event-invitees/user": Mod48,
  "discourse/components/post-calendar": Mod49,
  "discourse/components/region-input": Mod50,
  "discourse/components/toggle-invitees": Mod51,
  "discourse/components/upcoming-events-calendar": Mod52,
  "discourse/components/upcoming-events-list": Mod53,
  "discourse/connectors/before-main-outlet/embeddable-chat-channel-connector": Mod54,
  "discourse/connectors/before-topic-list-body/category-calendar": Mod55,
  "discourse/connectors/calendar-subscriptions-feeds/event-feeds": Mod56,
  "discourse/connectors/category-custom-settings/show-event-category-sorting-settings": Mod57,
  "discourse/connectors/chat-channel-card-cta/livestream-rsvp": Mod58,
  "discourse/connectors/chat-channel-preview-card-content/livestream-rsvp": Mod59,
  "discourse/connectors/discovery-list-container-top/category-events-calendar": Mod60,
  "discourse/connectors/header-topic-title-suffix/event-date-container": Mod61,
  "discourse/connectors/topic-list-after-title/event-badge": Mod62,
  "discourse/connectors/user-custom-preferences/region": Mod63,
  "discourse/controllers/admin-plugins/show/discourse-calendar-holidays": Mod64,
  "discourse/controllers/discourse-post-event-upcoming-events": Mod65,
  "discourse/controllers/discourse-post-event-upcoming-events/index": Mod66,
  "discourse/controllers/discourse-post-event-upcoming-events/mine": Mod67,
  "discourse/discourse-calendar-topic-zoom-route-map": Mod68,
  "discourse/discourse-event-upcoming-events-route-map": Mod69,
  "discourse/helpers/format-event-name": Mod70,
  "discourse/helpers/format-future-date": Mod71,
  "discourse/initializers/add-create-event-composer-action": Mod72,
  "discourse/initializers/add-event-ui-builder": Mod73,
  "discourse/initializers/add-events-create-topic-button": Mod74,
  "discourse/initializers/add-upcoming-events-to-sidebar": Mod75,
  "discourse/initializers/calendar-admin-plugin-configuration-nav": Mod76,
  "discourse/initializers/disable-sort": Mod77,
  "discourse/initializers/discourse-calendar": Mod78,
  "discourse/initializers/discourse-post-event-decorator": Mod79,
  "discourse/initializers/event-relative-date": Mod80,
  "discourse/initializers/livestream-chat-overrides": Mod81,
  "discourse/lib/calendar-locale": Mod82,
  "discourse/lib/calendar-view-helper": Mod83,
  "discourse/lib/colors": Mod84,
  "discourse/lib/discourse-markdown/discourse-calendar": Mod85,
  "discourse/lib/discourse-markdown/discourse-post-event-block": Mod86,
  "discourse/lib/discourse-markdown/livestream-preview": Mod87,
  "discourse/lib/event-preview": Mod88,
  "discourse/lib/event-recurrence": Mod89,
  "discourse/lib/event-relative-date": Mod90,
  "discourse/lib/fetch-zoom-join-payload": Mod91,
  "discourse/lib/format-event-for-calendar": Mod92,
  "discourse/lib/full-calendar-default-options": Mod93,
  "discourse/lib/guess-best-date-format": Mod94,
  "discourse/lib/livestream-rsvp": Mod95,
  "discourse/lib/livestream-utils": Mod96,
  "discourse/lib/load-zoom-meeting-sdk": Mod97,
  "discourse/lib/open-event-composer": Mod98,
  "discourse/lib/raw-event-helper": Mod99,
  "discourse/lib/regions": Mod100,
  "discourse/lib/round-time": Mod101,
  "discourse/lib/zoom-component-view-dom": Mod102,
  "discourse/lib/zoom-error": Mod103,
  "discourse/lib/zoom-meeting-session": Mod104,
  "discourse/models/discourse-post-event-event-stats": Mod105,
  "discourse/models/discourse-post-event-event": Mod106,
  "discourse/models/discourse-post-event-invitee": Mod107,
  "discourse/models/discourse-post-event-invitees": Mod108,
  "discourse/models/discourse-post-event-reminder": Mod109,
  "discourse/modifiers/open-links-in-new-tab": Mod110,
  "discourse/modifiers/zoom-component-view-layout": Mod111,
  "discourse/pre-initializers/rich-editor-extension": Mod112,
  "discourse/pre-initializers/transformers": Mod113,
  "discourse/routes/discourse-post-event-upcoming-events": Mod114,
  "discourse/routes/discourse-post-event-upcoming-events/default-index": Mod115,
  "discourse/routes/discourse-post-event-upcoming-events/default-mine": Mod116,
  "discourse/routes/discourse-post-event-upcoming-events/index": Mod117,
  "discourse/routes/discourse-post-event-upcoming-events/mine": Mod118,
  "discourse/routes/topic-zoom": Mod119,
  "discourse/services/create-event-composer": Mod120,
  "discourse/services/discourse-post-event-api": Mod121,
  "discourse/services/discourse-post-event-service": Mod122,
  "discourse/services/embeddable-chat": Mod123,
  "discourse/services/post-calendar": Mod124,
  "discourse/templates/admin-plugins/show/discourse-calendar-holidays": Mod125,
  "discourse/templates/discourse-post-event-upcoming-events": Mod126,
  "discourse/templates/discourse-post-event-upcoming-events/index": Mod127,
  "discourse/templates/discourse-post-event-upcoming-events/mine": Mod128,
  "discourse/templates/topic-zoom": Mod129,
};
export default compatModules;
